import { render, staticRenderFns } from "./ObjectManager.vue?vue&type=template&id=49bc3eca&scoped=true&"
import script from "./ObjectManager.vue?vue&type=script&lang=js&"
export * from "./ObjectManager.vue?vue&type=script&lang=js&"
import style0 from "./ObjectManager.vue?vue&type=style&index=0&id=49bc3eca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc3eca",
  null
  
)

export default component.exports